export const PAGE_TITLE = {
    '/user/details/myroles': 'My Roles',
    '/user/details/mymobiletokens': 'My Mobile Tokens',
    '/user/details/mylinkedusers': 'My Linked Users',
    '/user/details/mytwofactorauthentication': 'My two factor authentication',
    '/distributor/support/companymove': 'Company Move',
};
